import { render, staticRenderFns } from "./MyWalletConnectAddress.vue?vue&type=template&id=24148236&scoped=true"
import script from "./MyWalletConnectAddress.vue?vue&type=script&lang=ts"
export * from "./MyWalletConnectAddress.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24148236",
  null
  
)

export default component.exports